import { ACHIEVEMENTS_CONFIGS_MAP, AchievementName } from '@helios/achievement';
import { PalmettoIcon } from '@palmetto/dsm-components';
import { useTranslation, useComponentTracking } from '@helios/frontend-core';


import { BadgeIcon } from '../../../Badge/BadgeIcon/BadgeIcon';

export interface BadgeEarnedViewProps {
  achievementName: AchievementName;
}

export function BadgeEarnedView(props: BadgeEarnedViewProps) {
  const { achievementName } = props;
  const { t } = useTranslation();
  const pointsReward = ACHIEVEMENTS_CONFIGS_MAP[achievementName]?.pointsReward;

  useComponentTracking(`${achievementName}-badge-earned`);

  const achievementDisplayName = t(`badge.achievement.${achievementName}`);
  const title = t('badge.badgeEarned.title', { achievementName: achievementDisplayName });
  const description = t(`badge.badgeEarned.description.${achievementName}`, { defaultValue: '' });

  return (
    <div className="flex flex-col gap-24 h-full justify-center text-center text-text-primary items-center">
      <BadgeIcon className="w-[140px] h-[125px]" achievementName={achievementName} achieved />
      <h1 className="heading-600">{title}</h1>
      <div className="flex flex-col gap-8">
        <p className="label-600">+{t('common.pointsDisplay', { points: pointsReward })}</p>
        {description && (
          <div className="flex">
            <PalmettoIcon name="check" size="sm" aria-hidden="true" className="shrink-0 mr-4" />
            <p className="label-400">{description}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BadgeEarnedView;
